import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import authStore from '../stores/authStore'
import { routes } from '../utils/constants'


const useRenderOnAuthenticated = () => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!authStore.userIsLoggedIn) navigate(routes.LOGIN)
  }, [navigate])

  return authStore.userIsLoggedIn
}

export default useRenderOnAuthenticated
